export class EmployeeModel {
    public employeeId? :number;
        public title='';
        public firstName = '';
        public lastName = '';
        public employeeNo='';
        public gender='';
        public dOB='';
public dOJ='';
public designationId='';
public departmentId='';
public  countryId='';
public provinceId='';
public cityId='';
public phone='';
public contactNumber='';
public officialEmail='';
public employeeStatusId='';
public thumbnailImage='';
public signatureImage='';
public reportingTo='';
public divisionId='';
public toSource='';
public oldUserId='';
public oldUserNumber='';
public oldInitials='';
}
